import React, { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { Panel, Message } from 'rsuite'
import { IconButton, Icon, Table } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import InviteToProjectForm from './InviteToProjectForm'
//import InviteToProjectView from './InviteToProjectView'
import {
  sendInviteForm,
  deleteInvaite,
  getInviteForm,
  saveInviteAcceptanceBySe,
  saveInviteAcceptanceByProjectId,
} from '../../../redux/actions/inviteToProject'
import { startLoading, doneLoading } from '../../../utils/loading'
import ConfirmWidget from '../../../widgets/confirm/ConfirmWidget'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import { ERR_MSG, NOT_COMPLETE, RETRY_CONTACT_ADMIN, SUCCESS_MSG } from '../../../constants/msgText'
import AlertWidget from '../../confirm/AlertWidget'
import pathname from '../../../constants/pathname'

export default function InviteToProjectWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, isAcceptF } = props
  const { Column, HeaderCell, Cell } = Table
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)
  const [showSuccess, setShowSuccess] = useState(false)
  const [isShowConfirmDelete, setIsShowConfirmDelete] = useState(false)
  const [deleteData, setDeleteData] = useState()
  const [dataList, setDataList] = useState([])
  const [isShowAcceptRes, setIsShowAcceptRes] = useState(false)
  const [acceptType, setAcceptType] = useState()
  const [redirectProjectId, setRedirectProjectId] = useState()

  const { se } = useParams()
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    if (props?.schema?.invitedHistory?.items?.length > 0) {
      setDataList(props.schema.invitedHistory.items)
    }
  }, [props.schema])

  const handleCallService = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setShowSuccess(false)
    try {
      let response

      if (isAcceptF) {
        if (se) {
          response = await saveInviteAcceptanceBySe(se, request)
        } else {
          response = await saveInviteAcceptanceByProjectId(projectId, request)
        }

        if (response) {
          setRedirectProjectId(response.projectVersionId)
          setIsShowAcceptRes(true)
        } else {
          setIsError(true)
        }
      } else {
        response = await sendInviteForm(projectId, request)

        if (response) {
          setShowSuccess(true)
          setValue(formSchema.firstName.name)
          setValue(formSchema.lastName.name)
          setValue(formSchema.department.name)
          setValue(formSchema.email.name)

          if (isAcceptF) {
            setFormSchema(response?.forms?.inviteProject)
            setDataList(response?.forms?.inviteProject?.invitedHistory?.items)
          } else {
            handleGetDataList()
            setFormSchema(response?.forms?.inviteProject)
          }
        } else {
          setIsError(formSchema.buttonText + NOT_COMPLETE + ' ' + RETRY_CONTACT_ADMIN)
        }
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleDelete = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirmDelete(false)
    try {
      let response = await deleteInvaite(deleteData.id, projectId)
      console.log('response', response)
      if (response == 200) {
        handleGetDataList()

        setIsError(false)
      }
    } catch (e) {
      console.log(e)
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleGetDataList = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const response = await getInviteForm(projectId)
      setFormSchema(response.forms.inviteProject)
      setDataList(response?.forms?.inviteProject?.invitedHistory?.items)
    } catch (e) {
      console.log('error', e)
    }
    doneLoading()
    setIsLoading(false)
  }

  const onSubmit = (data) => {
    console.log('data', data)

    let request = {
      id: formSchema.id || null,
      projectVersionId: projectId,
      firstName: data.firstName,
      lastName: data.lastName,
      department: data.department,
      email: data.email,
      acceptType: data.acceptType,
    }

    setAcceptType(data.acceptType)

    console.log('request', request)
    handleCallService(request)
  }

  const handleOnDelete = (rowData) => {
    setDeleteData(rowData)
    setIsShowConfirmDelete(true)
  }

  const handleToOverView = () => {
    let redirecturl = ''
    if (acceptType == 1) {
      sessionStorage.setItem('projectId', redirectProjectId || projectId)
      sessionStorage.setItem('param', '')

      redirecturl = `${pathname.proposal.overview.overviewCoworker}`
    } else {
      redirecturl = `${pathname.dashboardRoot}`
    }
    window.location.href = redirecturl
    window.opener = null
  }

  return (
    <>
      {!formSchema.disabled && (
        <Panel
          shaded
          header={formSchema.header}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
        >
          {/* {isEdit && showCommandButton ? ( */}
          <InviteToProjectForm
            schema={formSchema}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
          />
          {/* ) : (
        <InviteToProjectView schema={formSchema} />
      )} */}

          {showCommandButton && (
            <>
              <hr />
              {isError && (
                <Message
                  showIcon
                  type="error"
                  description={formSchema.buttonText + NOT_COMPLETE + ' ' + RETRY_CONTACT_ADMIN}
                  style={{ marginBottom: 10 }}
                />
              )}

              {showSuccess && (
                <Message
                  closable
                  showIcon
                  type="success"
                  description={formSchema.buttonText + SUCCESS_MSG}
                  style={{ marginBottom: 10 }}
                />
              )}

              <SaveButton
                onClick={handleSubmit(onSubmit)}
                disabled={isLoading}
                icon={!formSchema.acceptType ? 'send' : 'save'}
              >
                {formSchema.buttonText}
              </SaveButton>
            </>
          )}
        </Panel>
      )}

      <br />
      {!isAcceptF && (
        <Panel
          shaded
          header={formSchema?.invitedHistory?.header}
          collapsible
          defaultExpanded
          ref={(section) => {
            setSection(section)
          }}
          style={{ marginBottom: 20 }}
        >
          <Table wordWrap height={400} data={dataList}>
            <Column flexGrow={1} minWidth={200}>
              <HeaderCell>
                <span>ชื่อ-สกุล</span>
              </HeaderCell>
              <Cell>
                {(rowData) => {
                  return <span>{rowData.firstName + ' ' + rowData.lastName}</span>
                }}
              </Cell>
            </Column>

            <Column width={150}>
              <HeaderCell>
                <span>หน่วยงาน</span>
              </HeaderCell>
              <Cell dataKey="department" />
            </Column>

            <Column width={150} minWidth={150} flexGrow={1}>
              <HeaderCell>
                <span>email</span>
              </HeaderCell>
              <Cell dataKey="email" />
            </Column>

            <Column width={190}>
              <HeaderCell>
                <span>วันที่ส่งคำเชิญ</span>
              </HeaderCell>
              <Cell dataKey="sendMailDate" />
            </Column>

            <Column width={120} fixed="right">
              <HeaderCell>สถานะ</HeaderCell>
              <Cell dataKey="status" style={{ textAlign: 'center' }} />
            </Column>
            {!isAcceptF && (
              <Column width={130} fixed="right">
                <HeaderCell>จัดการ</HeaderCell>
                <Cell>
                  {(rowData, index) => {
                    if (!rowData.isActive) {
                      return
                    }
                    return (
                      <div>
                        <IconButton
                          appearance="ghost"
                          className="rs-btn-ghost-cancel"
                          icon={<Icon icon="close" className="bt-gost-icon-none-radius-cancel" />}
                          onClick={() => {
                            handleOnDelete(rowData)
                          }}
                        >
                          ระงับ
                        </IconButton>
                      </div>
                    )
                  }}
                </Cell>
              </Column>
            )}
          </Table>
        </Panel>
      )}

      <ConfirmWidget
        title={`ยืนยันการระงับข้อมูลผู้ถูกเชิญ`}
        show={isShowConfirmDelete}
        detail={`ยืนยันการระงับข้อมูล ${deleteData?.firstName + ' ' + deleteData?.lastName}`}
        onCancle={() => setIsShowConfirmDelete(false)}
        onConfirm={handleDelete}
      />

      <AlertWidget
        title={`ผลการบันทึก`}
        show={isShowAcceptRes}
        detail={`บันทึกสำเร็จ`}
        onClose={handleToOverView}
      />
    </>
  )
}
